import { render, staticRenderFns } from "./TypeProductCreateUpdate.vue?vue&type=template&id=09dbbabf&"
import script from "./TypeProductCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./TypeProductCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports